module.exports = __webpack_public_path__ + "assets/circle-loading.48231951.svg";